import { Box, Modal, Typography } from "@mui/material";
import CustomButton from "components/Button";
import { useTranslation } from "react-i18next";
import { PopupMode } from "./ModalTrack";

interface IPopupInfoModalProps {
  modalMode: PopupMode;
  setIsModalOpen: () => void;
}

const MODAL_CONTENT: Record<Exclude<PopupMode, null>, { title: string; description: string }> = {
  offerLink: {
    title: "addMacros",
    description: "country={country}&city={city}&os={os}&os_version={os_version}&browser={browser}",
  },
  iosTrafficLink: {
    title: "iosLinkPopupTitle",
    description: "iosLinkPopupDescription",
  },
};

const PopupInfoModal = ({ modalMode, setIsModalOpen }: IPopupInfoModalProps) => {
  const { t } = useTranslation();
  const open = !!modalMode;
  const modalContent = modalMode && MODAL_CONTENT[modalMode];

  return (
    <Modal open={open} onClose={setIsModalOpen} aria-labelledby="popup-title" aria-describedby="popup-description">
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          borderRadius: "8px",
          padding: "32px 24px 24px 24px",
          bgcolor: "#FFFFFF",
          boxShadow: "0 0 4px 0 rgba(165, 163, 174, 0.3);",
          width: "90%",
          maxWidth: "400px",
          height: "auto",
          maxHeight: "90dvh",
          overflowY: "auto",
        }}
      >
        <Typography
          id="popup-title"
          component="h2"
          sx={{
            marginBottom: "14px",
            fontSize: "18px",
            fontWeight: 500,
            color: "#2E263D",
          }}
        >
          {t(modalContent?.title!)}
        </Typography>
        <Typography
          id="popup-description"
          component="p"
          sx={{
            marginBottom: "24px",
            fontSize: "14px",
            lineHeight: "1.35",
            fontWeight: 400,
            color: "#2E263D",
          }}
        >
          {t(modalContent?.description!)}
        </Typography>
        <CustomButton
          textButton={t("close")}
          height={40}
          customBgColor="#F4701B"
          customHoverColor="#F4701B"
          customBorderRadius="8px"
          customFontSize="14px"
          customTextTransform="none"
          onClick={setIsModalOpen}
        />
      </Box>
    </Modal>
  );
};

export default PopupInfoModal;
